import React, { memo, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import { List, ListItem, ListItemText } from '../../material-ui/List';
import { Badge } from '../../material-ui/Badge';
import { Panel } from '../../Panel/Panel';
import { useStyles } from '../useStyles';

const formatTime = (time) => {
    if (!time) {
        return '';
    }

    const date = new Date(time);
    const today = new Date();
    const sameDay = date.toDateString() === today.toDateString();

    return sameDay
        ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : date.toLocaleDateString([], { day: '2-digit', month: '2-digit' });
};

export const ThreadList = memo(({ chats, activeChat, search, onSearch, onSelect, className }) => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    const handleSearch = useCallback((value) => onSearch(value), [onSearch]);

    return (
        <div className={className}>
            <Panel
                title={translate('messenger.title')}
                search={{
                    value: search,
                    onSearch: handleSearch,
                    placeholder: translate('messenger.searchPlaceholder'),
                }}
            >
                <List>
                    {chats && chats.length > 0 ? (
                        chats.map((chat) => {
                            const selected = activeChat && activeChat.id === chat.id && activeChat.type === chat.type;

                            return (
                                <ListItem
                                    key={`${chat.type}_${chat.id}`}
                                    button={true}
                                    selected={selected}
                                    className={classnames(selected && classes.chatItemSelected)}
                                    onClick={() => onSelect(chat)}
                                >
                                    <ListItemText
                                        primary={chat.title || translate('messenger.untitledChat')}
                                        secondary={
                                            <span className={classes.chatPreview}>
                                                {chat.hasAttachment && (
                                                    <AttachFileIcon className={classes.chatPreviewClip} fontSize="inherit" />
                                                )}
                                                {chat.lastMessage ||
                                                    (chat.hasAttachment
                                                        ? translate('messenger.attachmentLabel')
                                                        : translate('messenger.noMessages'))}
                                            </span>
                                        }
                                    />
                                    <span>{formatTime(chat.lastMessageTime)}</span>
                                    {chat.unreadCount > 0 && (
                                        <Badge
                                            color="secondary"
                                            badgeContent={chat.unreadCount}
                                            max={999}
                                            style={{ marginLeft: 16, marginRight: 8 }}
                                        />
                                    )}
                                </ListItem>
                            );
                        })
                    ) : (
                        <ListItem>
                            <ListItemText primary={translate('messenger.noChats')} />
                        </ListItem>
                    )}
                </List>
            </Panel>
        </div>
    );
});

ThreadList.displayName = 'ThreadList';
